import { http } from "@/lib/http";

/**
 * Converts a PDF (page 1) to a PNG stored under `pdftoimage/`.
 * Mirrors Vue2's Psychometrics/Emergenetics.vue -> POST /api/pdftoimage.
 * Filename convention (per legacy): "<name>_<employeeId>.pdf".
 */
export function uploadEmergeneticsPdf(file) {
  const data = new FormData();
  data.append("file", file);
  return http
    .post("/api/pdftoimage", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
}
